import { cn } from '@change/ds-utils';

import { ThemeProvider } from '@change/ds-core-ui/next';

import { AmountButton } from 'src/app/shared/components/payments';

import { AmountButtonChip } from '../../sunriseHoldoutExperiment/components/AmountButtonChip';
import { useSunriseHoldoutExperiment } from '../../sunriseHoldoutExperiment/hooks/useSunriseHoldoutExperiment';

import { AmountInput } from './components/AmountInput';
import { useAmountSelector } from './hooks/useAmountSelector';

export function AmountSelector({ acceptMembership }: { acceptMembership: boolean }): JSX.Element {
	const {
		data: {
			amount,
			currency,
			currencySymbol,
			currencySymbolPosition,
			decimalSeparator,
			errorMessage,
			isSelected,
			isCustomAmount,
			showFractionNumber,
			value,
			placeholder,
			...useAmountSelectorData
		},
		actions: { onChange, onClick, onFocus },
	} = useAmountSelector();

	const { isSunriseEnabled, ...sunriseHoldoutExperiment } = useSunriseHoldoutExperiment({
		isSunriseEnabled: useAmountSelectorData.isSunriseEnabled,
	});

	const amountButtonProps = sunriseHoldoutExperiment.enabled
		? ({
				fontWeight: 'bold',
				textSize: 'default',
			} as const)
		: {};

	return (
		<ThemeProvider>
			<div className="flex w-full justify-center gap-2 pb-1 pt-3">
				<div
					className={cn({
						'basis-1/5': sunriseHoldoutExperiment.shouldUseBlueCards,
						'basis-1/4': !sunriseHoldoutExperiment.shouldUseBlueCards,
					})}
				>
					{sunriseHoldoutExperiment.shouldUseBlueCards ? (
						<AmountButtonChip
							onClick={onClick}
							isSelected={acceptMembership && isSelected}
							amount={amount}
							currency={currency}
						/>
					) : (
						<AmountButton
							dataQaAttribute="default-amount-button"
							amount={amount}
							currency={currency}
							isSelected={acceptMembership && isSelected}
							onClick={onClick}
							isSunriseEnabled={isSunriseEnabled}
							height="40px"
							{...amountButtonProps}
						/>
					)}
				</div>
				<div
					className={cn({
						'basis-4/5': sunriseHoldoutExperiment.shouldUseBlueCards,
						'basis-3/4': !sunriseHoldoutExperiment.shouldUseBlueCards,
					})}
				>
					<AmountInput
						currencySymbol={currencySymbol}
						errorMessage={errorMessage}
						isSelected={acceptMembership && isCustomAmount}
						onChange={onChange}
						onFocus={onFocus}
						value={value}
						placeholder={placeholder}
					/>
				</div>
			</div>
		</ThemeProvider>
	);
}
